///
/// EarthBrowser
///
/// Created by Matt Giger on 4/16/2026
/// Copyright (c) 2026 Geodata Labs
///

import { Button } from "@/components/ui/button"
import { useBetaStatus } from "@/hooks/useBetaStatus"
import { setSubscribeOpen } from "@/redux/dialogSlice"
import { useAppDispatch } from "@/redux/store"
import { useGetUserSubscriptionQuery } from "@/redux/userApi"
import { useAppSelector } from "@/redux/store"
import { PricingPlans } from "@shared-types/pricing-plans"
import { Clock, Gift, X } from "lucide-react"
import { useState } from "react"

export function BetaTransitionBanner() {
	const { isTransitionPeriod, daysRemaining } = useBetaStatus()
	const [dismissed, setDismissed] = useState(false)
	const dispatch = useAppDispatch()
	const userProfile = useAppSelector(state => state.user.userProfile)
	const { data: subscriptions } = useGetUserSubscriptionQuery(undefined, { skip: !userProfile })

	if (!isTransitionPeriod || dismissed || daysRemaining === null) {
		return null
	}

	const hasBetaYearly = subscriptions?.some(s => s.subscription_id === "beta_yearly" && s.status === "active")

	if (hasBetaYearly) {
		return (
			<div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-3 px-4 py-2.5 pt-[calc(0.625rem+var(--safe-area-inset-top))] bg-gradient-to-r from-emerald-600/90 to-teal-600/90 backdrop-blur-sm text-white text-sm">
				<Gift className="h-4 w-4 flex-shrink-0" />
				<span className="font-medium">
					Beta ends in {daysRemaining} {daysRemaining === 1 ? "day" : "days"} &mdash; your free year of access starts when the beta ends
				</span>
				<button
					onClick={() => setDismissed(true)}
					className="ml-1 p-1 rounded-full hover:bg-white/20 transition-colors"
					aria-label="Dismiss"
				>
					<X className="h-3.5 w-3.5" />
				</button>
			</div>
		)
	}

	return (
		<div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-3 px-4 py-2.5 pt-[calc(0.625rem+var(--safe-area-inset-top))] bg-gradient-to-r from-amber-600/90 to-orange-600/90 backdrop-blur-sm text-white text-sm">
			<Clock className="h-4 w-4 flex-shrink-0" />
			<span className="font-medium">
				Beta ends in {daysRemaining} {daysRemaining === 1 ? "day" : "days"} &mdash; subscribe at ${PricingPlans.yearly.price.toFixed(2)}/yr to keep full access
			</span>
			<Button
				size="sm"
				variant="secondary"
				className="rounded-full bg-white text-amber-700 hover:bg-white/90 h-7 px-3 text-xs font-semibold"
				onClick={() => dispatch(setSubscribeOpen(true))}
			>
				Subscribe
			</Button>
			<button
				onClick={() => setDismissed(true)}
				className="ml-1 p-1 rounded-full hover:bg-white/20 transition-colors"
				aria-label="Dismiss"
			>
				<X className="h-3.5 w-3.5" />
			</button>
		</div>
	)
}
